import React, {useState,useEffect} from 'react';
import '../../../App.css';
import Navbar from '../../../components/Navbar';
import Banner from '../../../components/Banner';
import Footer from '../../../components/Footer';
import Reaction from '../../../components/Reaction';
import IconWhatsapp from '../../../local-assets/icon-whatsapp.png';
import IconEmail from '../../../local-assets/icon-email.png';
import ThumbsUp from '../../../local-assets/thumbs-up.png';
import ThumbsDown from '../../../local-assets/thumbs-down.png';
import BreadCrumbHome from '../../../local-assets/breadcrumb-home.png';
import Contact from '../../../components/Contact';
import LastUpdate from '../../../components/LastUpdate';


import LotReserveParkingBanner from '../../../local-assets/faq-detail/banner-lot-reserve-parking.svg';
import DetailValidasiKtp1 from '../../../local-assets/faq-detail/detail-validasi-ktp-v1.png';
import DetailValidasiKtp2 from '../../../local-assets/faq-detail/detail-validasi-ktp-v2.png';
import DetailValidasiKtp3 from '../../../local-assets/faq-detail/detail-validasi-ktp-v3.png';

const Index = () => {
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  const renderContent = (title, subTitle, content, srcImg) => (
    <div className="flex flex-col md:flex-row gap-8 md:gap-16 mb-16 md:mb-24">
      <div className="w-full md:w-1/2 text-left">
        <p className="text-[#F36F21] font-bold text-sm mb-3">
          {title}
        </p>
        <h3 className="text-xl md:text-2xl font-bold text-[#101828] mb-4 leading-snug">
          {subTitle}
        </h3>
        <p className="text-[#475467] text-sm md:text-base leading-relaxed pr-0 md:pr-4">
          {content}
        </p>
      </div>

      {/* Kolom Kanan: Gambar */}
      <div className="w-full md:w-1/2 flex justify-center md:justify-end">
        {/* Background abu-abu muda membungkus gambar */}
        <div className="rounded-[2rem] w-full max-w-[480px] flex justify-center items-center">
          <img 
            src={srcImg} 
            alt={subTitle} 
            className="w-full h-auto object-contain" 
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className="bg-white min-h-screen  flex flex-col">
      <Navbar />
      <Banner
          image={process.env.REACT_APP_S3 + "banner_faq.png"} 
          beforePage="FAQ"
          currentPage="Detail FAQ" 
      />
      <div className="mx-auto px-4 md:px-24 w-full relative z-10 mb-16">
          <div className="rounded-2xl md:rounded-3xl">
              <div className="mb-10 md:mb-16">
                  <h1 className="text-2xl md:text-3xl lg:text-3xl font-bold text-[#101828] mb-6 leading-snug">
                      Kenapa validasi KTP saya ditolak & bagaimana cara mengatasinya ?
                  </h1>
              </div>
              <div className="w-full">
                {renderContent(
                  "Alasan penolakan ke-1",
                  "Format foto KTP tidak sesuai",
                  "Foto KTP yang kamu submit harus jelas dan tidak blur, selain itu harus masuk kedalam area foto yang sudah disediakan. Hal ini dapat mempermudah kami dalam memvalidasi KTP kamu",
                  DetailValidasiKtp1
                )}
                {renderContent(
                  "Alasan penolakan ke-2",
                  "Foto selfie mu tidak sesuai",
                  "Selain foto KTP pastikan juga selfie kamu sudah jelas dan terang yah, agar kami dapat memvalidasi bahwa kamu adalah pemilik KTP yang kamu input",
                  DetailValidasiKtp2
                )}
                {renderContent(
                  "Alasan penolakan ke-3",
                  "Data yang kamu input tidak sesuai dengan KTP",
                  "Yuk cek lagi apakah data yang kamu input seperti nama, NIK & tanggal lahir sudah sesuai dengan yang tertera pada KTP milikmu",
                  DetailValidasiKtp3
                )}
              </div>
              <LastUpdate/>
          </div>
      </div>
      <Contact />
      <Footer />
    </div>
  );
}

export default Index;